import { render, staticRenderFns } from "./JournalCommentStatusIndicator.vue?vue&type=template&id=554dbdc5"
import script from "./JournalCommentStatusIndicator.vue?vue&type=script&lang=ts"
export * from "./JournalCommentStatusIndicator.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports